module.exports = __webpack_public_path__ + "static/media/background_A.95c23cf1.jpg";